import { Box, Typography, Stack, Link } from "@mui/material";
import config from "../config";

export default function About() {
  return (
    <Box sx={{ maxWidth: 600, mx: "auto", textAlign: "center", py: { xs: 4, sm: 6 } }}>
      <Box
        component="img"
        src="/images/logo.png"
        alt="DataStar"
        sx={{ height: 64, width: 64, borderRadius: 1.5, mb: 2 }}
      />
      <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: "-0.02em", mb: 1 }}>
        DataStar
      </Typography>
      <Stack spacing={0.5}>
        <Typography variant="body2" color="text.secondary">Version {config.appVersion}</Typography>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Absolute Technology
        </Typography>
        <Typography variant="body2" sx={{ mt: 2 }}>
          <Link href="mailto:sales@absolute.technology">sales@absolute.technology</Link>
        </Typography>
      </Stack>
    </Box>
  );
}
